import ToastHelper from '@launchpad/util/ToastHelper';
import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import { Link, Redirect } from 'react-router-dom';
import i18n from '../../../i18n';
import {
  AppLayoutWithCard,
  FormSubmitWrapper,
  FormHandler,
  InputField,
  OverrideService
} from '../../../index';
import ForgotPasswordModel from '../models/ForgotPasswordModel';

export default class ForgotPassword extends Component {
  // formHandler: FormHandler;

  constructor(props) {
    super(props);

    // Initial state
    this.formHandler = new FormHandler(
      this,
      new ForgotPasswordModel({
        email: ' '
      }),
      {
        redirect: false
      }
    );
    this.formHandler.on('submitSuccess', data => {
      if (data.success) {
        setTimeout(() => {
          this.setState({
            redirect: true
          });
        }, 1000);
      }
    });
  }

  componentDidMount() {
    this.setState(state => ({
      ...state,
      record: {
        ...state.record,
        email: '',
        remember: false
      }
    }));
  }

  onSubmitSuccess(data) {
    if (data.success) {
      ToastHelper.show(data.message, 'success');
    }
  }

  _getModalMessage(data) {
    if (!data.success) {
      return data.message;
    }
    return data.message;
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/login" />;
    }
    const { formHandler } = this;
    return (
      <AppLayoutWithCard>
        <h4>
          <Trans>Forgot your password?</Trans>
        </h4>
        <p>
          <Trans>
            Don’t worry. We’ll reset your password and
            <br /> send you a link to create a new one.
          </Trans>
        </p>
        <div className="form-wrapper">
          <FormSubmitWrapper
            formHandler={formHandler}
            buttonClass="gold-button"
            to="/login"
            invertedBtn={
              OverrideService.getOverrides()['inverted-button'] || false
            }
            buttonText="RESET PASSWORD"
            getModalMessage={data => this._getModalMessage(data)}
          >
            <div className="login-input-wrapper">
              <InputField
                className="input-group"
                materialProps={{
                  fullWidth: true
                }}
                autoComplete={this.state.record.email}
                label={i18n.t('Enter E-mail')}
                name="email"
                type="email"
                // placeholder={'Enter E-mail'}
                InputLabelProps={{
                  shrink: true
                }}
                value={this.state.record.email}
                handler={formHandler}
              />
            </div>
          </FormSubmitWrapper>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: 20
            }}
          >
            <Link
              to="/login"
              style={{
                textDecoration: 'none',
                fontWeight: 'lighter',
                fontSize: 15
              }}
            >
              <Trans>Back to login</Trans>
            </Link>
          </div>
        </div>
      </AppLayoutWithCard>
    );
  }
}
